import { Injectable } from '@angular/core';
import { APIClient } from 'src/app/core/api-client/contracts/api-client.service';
import { LogEntity, LogLevel } from '../models/LogEntity';
@Injectable({
    providedIn: 'root'
})
export class LoggingService {
    IsLogged:boolean = false;
    baseUri = 'loggerservice';
    constructor(private apiClient: APIClient) { }

    errorLog(message: string): void {
        this.saveLogToFile(message, LogLevel.Error);
    }

    activityLog(message: string): void {
        this.saveLogToFile(message, LogLevel.Info);
    }

    debugLog(message: string): void {
        this.saveLogToFile(message, LogLevel.Debug);
    }

    traceLog(message: string): void {
        this.saveLogToFile(message, LogLevel.Trace);
    }
    private saveLogToFile(message: string, level: LogLevel): void {
        const obj: LogEntity = {
            message: message,
            logLevel: level
        };

        this.apiClient.post<LogEntity>(`${this.baseUri}/log`, obj).subscribe(() => {
            this.IsLogged= true;
        });
    }

}